export default "__VITE_ASSET__DzKG_A_3__"